import React from 'react';
import { useTranslation } from 'react-i18next';
import ExpandedListTab from '../ExpandedListTab';
import {
    cashLimitUploadEventType,
} from '../../types';
import ReadonlyField from '../fields/ReadonlyField';
import CashLimitConfirmationFileDownloadButton from '../buttons/CashLimitConfirmationFileDownloadButton';
import DateTime, {
    LONG_DATETIME,
} from '../DateTime';
import { createUserValue } from '../../utils';
import { getCashLimitUploadOutcome } from '../../utils/CashLimitUploadOutcome';

CashLimitUploadEventDetailTab.propTypes = {
    cashLimitUploadEvent: cashLimitUploadEventType.isRequired,
};

function CashLimitUploadEventDetailTab(props) {
    const {
        cashLimitUploadEvent,
    } = props;
    const { t } = useTranslation();
    return (
        <ExpandedListTab
            className="cash-limit-upload-event-detail-tab"
            title={t('cash-limit-upload-events.cash-limit-upload-event-detail')}
        >
            <div className="rich-list-row-expanded--fields">
                <ReadonlyField
                    label={t('cash-limit-upload-events.timestamp')}
                    value={<DateTime value={cashLimitUploadEvent.uploadTimestamp} format={LONG_DATETIME} />}
                    className="cash-limit-upload-event-detail-tab--fields--timestamp"
                />
                <ReadonlyField
                    label={t('cash-limit-upload-events.filename')}
                    value={cashLimitUploadEvent.fileName}
                    className="cash-limit-upload-event-detail-tab--fields--filename"
                />
                <ReadonlyField
                    label={t('cash-limit-upload-events.export-timestamp')}
                    value={<DateTime value={cashLimitUploadEvent.exportTimestamp} format={LONG_DATETIME} />}
                    className="cash-limit-upload-event-detail-tab--fields--export-timestamp"
                />
                <ReadonlyField
                    label={t('cash-limit-upload-events.uploader')}
                    value={createUserValue(cashLimitUploadEvent.uploader, false)}
                    className="cash-limit-upload-event-detail-tab--fields--uploader"
                />
                <ReadonlyField
                    label={t('cash-limit-upload-events.outcome')}
                    value={getCashLimitUploadOutcome(cashLimitUploadEvent.outcome).translate(t)}
                    className="cash-limit-upload-event-detail-tab--fields--outcome"
                />
            </div>
            <div className="rich-list-row-expanded--buttons">
                <div className="rich-list-row-expanded--buttons--left">
                    <CashLimitConfirmationFileDownloadButton confirmationFileId={cashLimitUploadEvent.cashLimitConfirmationFileId} />
                </div>
                <div className="rich-list-row-expanded--buttons--middle" />
                <div className="rich-list-row-expanded--buttons--right" />
            </div>
        </ExpandedListTab>
    );
}

export default CashLimitUploadEventDetailTab;
